import { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { useFirebaseApp, AuthProvider, FirestoreProvider } from 'reactfire';
import { ThemeProvider, CssBaseline, CircularProgress } from '@mui/material';
import { SnackbarProvider } from 'notistack';

import { theme } from './styled/theme';
import { AppRoot, LoaderContainer } from './styled/App.styled';
import { AppRoutes } from './components';

function App() {
  const firestoreInstance = getFirestore(useFirebaseApp());
  const authInstance = getAuth(useFirebaseApp());

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider autoHideDuration={3000}>
        <FirestoreProvider sdk={firestoreInstance}>
          <AuthProvider sdk={authInstance}>
            <BrowserRouter>
              <Suspense
                fallback={
                  <LoaderContainer>
                    <CircularProgress />
                  </LoaderContainer>
                }
              >
                <AppRoot>
                  <AppRoutes />
                </AppRoot>
              </Suspense>
            </BrowserRouter>
          </AuthProvider>
        </FirestoreProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
